var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DrSearch',{attrs:{"queryParams":_vm.queryParams,"fullDate":_vm.fullDate}}),_vm._v(" "),_c('DrList',{attrs:{"queryParams":_vm.queryParams,"fullDate":_vm.fullDate,"fieldItems":_vm.fieldItems}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9a6e698","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/content/ContentStatistics.vue
// module id = null
// module chunks = 